/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RouteLocationInput
 */
export interface RouteLocationInput {
    /**
     * 
     * @type {string}
     * @memberof RouteLocationInput
     */
    airportCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RouteLocationInput
     */
    cityCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RouteLocationInput
     */
    countryCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RouteLocationInput
     */
    regionCode?: string | null;
}

export function RouteLocationInputFromJSON(json: any): RouteLocationInput {
    return RouteLocationInputFromJSONTyped(json, false);
}

export function RouteLocationInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): RouteLocationInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'airportCode': !exists(json, 'airportCode') ? undefined : json['airportCode'],
        'cityCode': !exists(json, 'cityCode') ? undefined : json['cityCode'],
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'regionCode': !exists(json, 'regionCode') ? undefined : json['regionCode'],
    };
}

export function RouteLocationInputToJSON(value?: RouteLocationInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'airportCode': value.airportCode,
        'cityCode': value.cityCode,
        'countryCode': value.countryCode,
        'regionCode': value.regionCode,
    };
}


